exports.f = Object.getOwnPropertySymbols;
